import {HttpBackend, HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {ACCESS_TOKEN_KEY} from './session.service';

class SecureHttpHandler implements HttpHandler {

  http = inject(HttpClient);

  constructor(private httpHandler: HttpHandler) {
  }

  handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
    const headers = new HttpHeaders().set('authorization', `Bearer ${sessionStorage.getItem(ACCESS_TOKEN_KEY)}`);
    return this.httpHandler.handle(req.clone({url: req.url, headers: headers}));
  }
}


@Injectable()
export class SecureHttp extends HttpClient {

  constructor(backend: HttpBackend) {
    super(new SecureHttpHandler(backend));
  }

}
